import { Modal } from 'bootstrap';
import Cookies from 'js-cookie';
import DOMPurify from 'dompurify';
import { __ } from '@wordpress/i18n';
import PhotoSwipeLightbox from 'photoswipe/src/js/lightbox/lightbox.js';
let lazyObserver = new IntersectionObserver(
  (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        theme.lazyloadImage(entry.target);
        observer.unobserve(entry.target);
      }
    });
  },
  {
    rootMargin: "0px 0px -50px 0px",
  }
);

const getScrollbarWidth = () => {
  const container = document.createElement('div');
  document.body.appendChild(container);
  container.style.overflow = 'scroll';
  const inner = document.createElement('div');
  container.appendChild(inner);
  const width = container.offsetWidth - inner.offsetWidth;
  document.body.removeChild(container);
  return width;
};

const mediaQuery = window.matchMedia('(min-width: 992px)');
const mediaQueryReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

export let theme = (function (document, window, _) {
  return {
    blockColumnSize: function (column) {
      const styles = getComputedStyle(column);
      const flexBasis = styles.getPropertyValue('flex-basis');
      if (flexBasis) {
        column.setAttribute('data-basis', flexBasis);
      }
      mediaQuery.addEventListener('change', theme.handleColumnResize.bind(this, column));
      this.handleColumnResize(column);
    },
    handleColumnResize: function (column, e) {
      if (e && !e.matches) {
        column.style.flexBasis = '100%';
      } else {
        column.style.flexBasis = column.dataset.basis;
      }
    },
    blockImageTextAltLayout(mediaText) {
      const figureImage = mediaText.querySelector('img');
      const imageAlt = figureImage.getAttribute('alt');
      const linkAnchor = mediaText.querySelector('a');
      mediaText.style.gridTemplateColumns = '';
      if (imageAlt) {
        const sideDom = document.createElement("div");
        const innerSpan = document.createElement("span");
        sideDom.classList.add('side-image-title');
        innerSpan.innerText = DOMPurify.sanitize(imageAlt);
        sideDom.appendChild(innerSpan);
        mediaText.appendChild(sideDom);
        theme.blockImageTextAltSize(mediaText);
      }
      if (linkAnchor) {
        const anchorClone = document.createElement("div");
        anchorClone.classList.add('media-text--link');
        anchorClone.innerHTML = DOMPurify.sanitize(`<a class="btn btn-lg btn-primary" href="${linkAnchor.getAttribute('href')}">${__('Leggi di più', 'museoscienze')}</a>`, { USE_PROFILES: { html: true } });
        mediaText.appendChild(anchorClone);
      }
    },
    blockImageTextAltSize(mediaText) {
      const element = mediaText.querySelector('.side-image-title span');
      const figure = mediaText.querySelector('.wp-block-media-text__media');
      const elementHeight = getComputedStyle(figure).getPropertyValue('height');
      element.style.maxWidth = elementHeight;
    },
    init: function () {
      const scrollbarWidth = getScrollbarWidth();
      const mediaTexts = document.querySelectorAll('.wp-block-media-text');
      const scrollTopBtn = document.querySelector(".btn-to-top");
      const menuHideLinkTop = [
        ...document.querySelectorAll(".hyper-menu-group > a"),
      ];
      const menuHideLinks = [
        ...document.querySelectorAll(
          ".hyper-menu-group > .dropdown-menu > .menu-item.hide > a"
        ),
        ...menuHideLinkTop,
      ];
      const menuRemoveText = [...document.querySelectorAll(".hide-link > a")];
      const backLinks = [...document.querySelectorAll(".dom-link-back")];
      const wpColumns = [...document.querySelectorAll(".wp-block-column")];
      const footerLinks = [
        ...document.querySelectorAll(".footerContainer .dropdown-toggle"),
      ];
      const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

      const mediaZoom = document.querySelector('.z-image');
      document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);


      let hideAnimationDuration = 400, showAnimationDuration = 400, zoomAnimationDuration = 400;

      // if (mediaQueryReducedMotion.matches) {
      //   hideAnimationDuration = 0;
      //   showAnimationDuration = 0;
      //   zoomAnimationDuration = 0;
      // }

      if (mediaZoom) {
        const zoomingChildren = mediaZoom.querySelectorAll('.photo-zoom');
        const lightbox = new PhotoSwipeLightbox({
          gallery: mediaZoom,
          hideAnimationDuration,
          showAnimationDuration,
          zoomAnimationDuration,
          children: zoomingChildren,
          closeTitle: 'Chiudi il popup',
          zoomTitle: 'Ingrandisci la foto',
          arrowPrevTitle: 'Foto precedente',
          arrowNextTitle: 'Foto successiva',

          errorMsg: 'Errore! La foto non si carica correttamente',
          indexIndicatorSep: ' di ',
          allowPanToNext: false,
          pswpModule: () => import('photoswipe')
        });
        lightbox.init();
      }
      if (mediaTexts.length) {
        mediaTexts.forEach((el) => {
          theme.blockImageTextAltLayout(el);
        });
      }

      window.addEventListener('resize', _.debounce(() => {
        mediaTexts.forEach((el) => {
          theme.blockImageTextAltSize(el);
        });
      }), 200);

      if (wpColumns.length) {
        wpColumns.forEach(col => {
          theme.blockColumnSize(col);
        });
      }

      if (backLinks) {
        backLinks.forEach((element) => {
          element.addEventListener("click", () => history.back());
        });
      }
      if (footerLinks) {
        footerLinks.forEach((element) => {
          element.removeAttribute("data-toggle");
          element.removeAttribute("href");
        });
      }

      if (scrollTopBtn) {
        scrollTopBtn.addEventListener("click", () => {
          if (isSmoothScrollSupported) {
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          } else {
            window.scrollTo(0, 0);
          }
        }
        );
      }
      if (menuRemoveText) {
        menuRemoveText.forEach((e) => {
          e.textContent = "\xa0";
        });
      }
      if (menuHideLinks) {
        menuHideLinks.forEach((e) => {
          const button = document.createElement('span');
          button.innerHTML = e.innerHTML;
          button.classList.add('no-hover', 'text-uppercase', ...e.classList.values());
          e.replaceWith(button);
        });
      }
    },
    navbarLayout: function () {

      const logoMain = document.querySelector(".logo-image");
      const logoAlt = document.querySelector(".logo-image--alt");
      const body = document.querySelector('body');

    },
    lazyloadImage: function (image) {
      image.classList.remove("lazy");
      if (image.tagName === 'IMG' && image.hasAttribute('data-imgsrc')) {
        const src = image.getAttribute('data-imgsrc');
        image.setAttribute('src', src);
      }
    },
    initModal: function () {
      const modalEl = document.getElementById('ett-modal');
      if (!modalEl || Cookies.get(modalEl.dataset.cookie)) {
        return;
      }
      const modal = new Modal(modalEl);
      modalEl.querySelector('.ett-modal-read').addEventListener('click', () => {
        Cookies.set(modalEl.dataset.cookie, '1', { expires: 365, path: '/' });
        modal.hide();
      });
      setTimeout(() => modal.show(), 2000);
    },
  };
})(document, window, _);
document.addEventListener("DOMContentLoaded", () => {
  theme.init();
  theme.initModal();

  const lazyImages = [...document.querySelectorAll(".lazy-image")];
  if (lazyImages) {
    lazyImages.forEach((element) => {
      lazyObserver.observe(element);
    });
  }
});
